import apiService from '../apiService';

export const tenantAccessAPI = apiService.injectEndpoints({
  endpoints: (builder) => ({
    searchTenantAccessUsers: builder.query({
      query: (paramsObj) => ({
        url: '/tenant-access/v1/users',
        params: paramsObj,
      }),
    }),
    searchTenantAccessTenants: builder.query({
      query: (paramsObj) => ({
        url: '/tenant-access/v1/tenants',
        params: paramsObj,
      }),
    }),
    validateTenantIds: builder.mutation({
      query: (body) => ({
        url: '/tenant-access/v1/tenants/validate',
        method: 'POST',
        body,
      }),
    }),
    getTenantAccessApps: builder.query({
      query: () => ({
        url: '/tenant-access/v1/apps',
      }),
    }),
    previewTenantAccess: builder.query({
      query: (body) => ({
        url: '/tenant-access/v1/preview',
        method: 'POST',
        body,
      }),
    }),
    getTenantAccessJob: builder.query({
      query: (id) => ({
        url: `/tenant-access/v1/jobs/${id}`,
      }),
    }),
    getCurrentTenantAccessJob: builder.query({
      query: () => ({
        url: '/tenant-access/v1/jobs/current',
      }),
    }),
    startTenantAccessJob: builder.mutation({
      query: (body) => ({
        url: '/tenant-access/v1/jobs',
        method: 'POST',
        body,
      }),
    }),
    retryTenantAccessJob: builder.mutation({
      query: (id) => ({
        url: `/tenant-access/v1/jobs/${id}/retry`,
        method: 'POST',
      }),
    }),
    searchTenantAccessAudit: builder.query({
      query: (paramsObj) => ({
        url: '/tenant-access/v1/audit',
        params: paramsObj,
      }),
    }),
    exportTenantAccessAudit: builder.query({
      query: (paramsObj) => ({
        url: '/tenant-access/v1/audit/export',
        params: paramsObj,
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useSearchTenantAccessUsersQuery,
  useSearchTenantAccessTenantsQuery,
  useValidateTenantIdsMutation,
  useGetTenantAccessAppsQuery,
  usePreviewTenantAccessQuery,
  useGetTenantAccessJobQuery,
  useGetCurrentTenantAccessJobQuery,
  useStartTenantAccessJobMutation,
  useRetryTenantAccessJobMutation,
  useSearchTenantAccessAuditQuery,
  useLazyExportTenantAccessAuditQuery,
} = tenantAccessAPI;
